import { Badge } from "@/components/ui/Badge";
import { EM_DASH } from "@/lib/utils";

import { firmwareFeatureChipIds, type FirmwareFeatureChipId } from "./firmwareFeatureChipIds";
import type { FirmwareFeature } from "./firmwareApi";

const CHIP_CLASS: Record<FirmwareFeatureChipId, string> = {
  N: "bg-sky-100 text-sky-800",
  B: "bg-violet-100 text-violet-800",
  W: "bg-emerald-100 text-emerald-800",
  "W-HC": "bg-orange-100 text-orange-900",
  Q: "bg-amber-100 text-amber-900",
};

export function FirmwareFeatureChips({ feature }: { feature: FirmwareFeature | null }): JSX.Element {
  const chips = firmwareFeatureChipIds(feature);
  if (chips.length === 0) return <>{EM_DASH}</>;
  return (
    <span className="inline-flex flex-nowrap items-center gap-1">
      {chips.map((chip) => (
        <Badge key={chip} className={CHIP_CLASS[chip]}>
          {chip}
        </Badge>
      ))}
    </span>
  );
}
